module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.3-254.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.3.md
// module id = 698
// module chunks = 258